module.exports = __webpack_public_path__ + "static/media/logo.3fb4d622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 331
// module chunks = 0